module.exports = __webpack_public_path__ + "assets/img/btn-view-843e703e.png";